// extracted by mini-css-extract-plugin
module.exports = {"savedFiltersTags":"SavedFiltersList_savedFiltersTags__jBAi1","tag":"SavedFiltersList_tag__2dgK0","chosenTag":"SavedFiltersList_chosenTag__YMnV9"};